import React, { ReactNode } from 'react'
import ImpactList from './ImpactList'

interface PublishImpactBodyProps {
  usedIntro: ReactNode
  usedItems: string[]
  noUsageText: string
  locationsIntro: string
  locations: string[]
  noLocationsText: string
}

const PublishImpactBody = ({
  usedIntro,
  usedItems,
  noUsageText,
  locationsIntro,
  locations,
  noLocationsText
}: PublishImpactBodyProps) => {
  if (usedItems.length === 0) return <p className="mb-0">{noUsageText}</p>

  return (
    <>
      <ImpactList intro={usedIntro} items={usedItems} />
      <ImpactList
        intro={locationsIntro}
        items={locations}
        emptyText={noLocationsText}
        className="mb-0"
      />
    </>
  )
}

export default PublishImpactBody
